import { gql } from '__generated__'

export const SELLER_LIST_BUILDER_PREVIEW_QUERY = gql(/* GraphQL */`
  query SellerListBuilderPreview($input: SellerListBuilderPreviewInput!) {
    sellerListBuilderPreview(input: $input) {
      id
      address {
        ... on AddressVerified {
          line1
          city
          state
          postalCode
          location {
            latitude
            longitude
          }
        }
        ... on AddressUnverified {
          line1
          city
          state
          postalCode
          location {
            latitude
            longitude
          }
        }
      }
      ownerDetails {
        ownerClassification
        ownerStatus
        isVacant
        isForeclosure
        isSenior
        isHomestead
        isTaxDelinquent
        owners {
          name {
            full
          }
        }
        contactAddress {
          ... on AddressVerified {
            line1
            city
            state
            postalCode
          }
          ... on AddressUnverified {
            line1
            city
            state
            postalCode
          }
        }
      }
      buildingDetails {
        bedroomsCount
        bathroomsCount {
          full
          half
          total
        }
        garageSpacesCount
        buildingAreaSqft
        livingAreaSqft
        yearBuilt
      }
      landDetails {
        standardizedUseType
        lotAreaSqft
        lotAreaAcres
        subdivision
        location {
          latitude
          longitude
        }
      }
      lastSale {
        saleDate
        saleAmount
      }
      valuationDetails {
        value
        equity
        loanToValue
      }
      mlsPropertyListings(first: 1) {
        edges {
          node {
            resoPropertyListing {
              listPrice
              standardStatus
            }
            media(first: 25, types: [Jpeg, Png]) {
              edges {
                node {
                  mediaURL
                  shortDescription
                }
              }
            }
          }
        }
      }
    }
  }
`)
